// Shared primitives for the creative-chat surfaces (SideChat, AssistantChat,
// ConversationChat, ConversationInterview). Keeping the markers, the text join,
// and the API base in ONE place stops the parsers from drifting across the chat
// renderers.

// Relative URL falls back to the Vite proxy. We deliberately default to a
// relative base instead of pointing at the in-cluster API: in the dev k3s setup
// port 8080 is the in-cluster API port and is NOT exposed to the host — only the
// proxy on 8081 is. A relative URL therefore routes through the Vite proxy in dev
// and hits the same origin in prod.
export const API_BASE = import.meta.env.VITE_API_URL || ''

/** A single AI-SDK message part. Intentionally loose — parts carry tool/file/text
 *  shapes the SDK types as a union we only read a few fields off. */
export type Part = Record<string, unknown>

/** `[[options: a | b | c]]` → tappable quick replies. */
export const OPTIONS_RE = /\[\[options:\s*([^\]]+)\]\]/i
/** `[[subject: TWO TO FOUR WORDS]]` → the topic label shown above the question. */
export const SUBJECT_RE = /\[\[subject:\s*([^\]]+)\]\]/i

/** Parses `[[options: a | b | c]]` into up to four trimmed picks. */
export function parseOptions(text: string): string[] {
  const m = text.match(OPTIONS_RE)
  if (!m) return []
  return m[1]
    .split('|')
    .map(s => s.trim())
    .filter(Boolean)
    .slice(0, 4)
}

/** Joins all text parts of a message into one string. */
export function partsText(parts?: Part[]): string {
  return Array.isArray(parts)
    ? parts
        .filter(p => p.type === 'text')
        .map(p => p.text as string)
        .join('')
    : ''
}
